/* import __COLOCATED_TEMPLATE__ from './sessions-grid-offering-table-offerings.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { map } from 'rsvp';
import { TrackedAsyncData } from 'ember-async-data';
import { sortBy } from 'ilios-common/utils/array-helpers';
let SessionsGridOfferingTableOfferingsComponent = (_class = class SessionsGridOfferingTableOfferingsComponent extends Component {
  get sortedOfferingsData() {
    return new TrackedAsyncData(this.sortOfferings(this.args.offeringTimeBlock));
  }
  get sortedOfferings() {
    return this.sortedOfferingsData.isResolved ? this.sortedOfferingsData.value : [];
  }
  async sortOfferings(offeringTimeBlock) {
    const sortProxies = await map(offeringTimeBlock.offerings, async offering => {
      const learnerGroups = await offering.learnerGroups;
      return {
        title: learnerGroups.length ? learnerGroups.slice()[0].title : null,
        offering
      };
    });
    return sortBy(sortProxies, 'title').map(proxy => proxy.offering);
  }
}, _applyDecoratedDescriptor(_class.prototype, "sortedOfferingsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sortedOfferingsData"), _class.prototype), _class);
export { SessionsGridOfferingTableOfferingsComponent as default };